// Copyright 2018 The MathWorks, Inc.

/**
 * This defines a list of constants identifying the components that may reside on a status bar
 */
define([], function () {
    return {
        STATUS_BAR_ROOT: "StatusBarRoot",
        STATUS_BAR: "StatusBar",
        STATUS_GROUP: "StatusGroup",
        STATUS_LABEL: "StatusLabel",
        STATUS_PROGRESS_BAR: "StatusProgressBar",
        STATUS_PUSH_BUTTON: "StatusPushButton",
        STATUS_TEXT_FIELD: "StatusTextField",
        STATUS_TOGGLE_BUTTON: "StatusToggleButton"
    };
});